/**
 * Client-side locale detection utility
 * Extracts locale from URL path and falls back to browser language
 * @param pathname - The current URL pathname
 * @returns { shortLocale: string, fullLocale: string } - The short locale (e.g., "fr") and the full locale (e.g., "fr-fr")
 */
export function detectClientLocale(pathname: string): {
	shortLocale: string
	fullLocale: string
} {
	// Extract locale from URL path
	const pathSegments = pathname.split('/')
	const fullLocaleSegment = pathSegments[1] || ''

	if (fullLocaleSegment) {
		// Return full locale or just language part based on parameter
		return {
			shortLocale: fullLocaleSegment.split('-')[0],
			fullLocale: fullLocaleSegment,
		}
	}

	// Fallback to browser language
	if (typeof navigator !== 'undefined' && navigator.language) {
		const browserLocale = navigator.language
		return {
			shortLocale: browserLocale.split('-')[0],
			fullLocale: browserLocale,
		}
	}

	// Ultimate fallback
	return { shortLocale: 'en', fullLocale: 'en' }
}
